<template>
  <section>
    <div class="container cont checkout-step checkout-step--clean">
      <form class="checkout-step__form checkout-step__form--wide" method="post" @submit.prevent="continueSale()">
        <div class="checkout-step__intro">
          <small class="form-text text-muted checkout-step__eyebrow">Paso 2 de 4</small>
          <h2 class="text-justify va-h6 checkout-step__title"><strong>Datos del comprador</strong></h2>
          <small class="form-text text-muted checkout-step__hint">Usa un solo correo y define al responsable del retiro antes del pago.</small>
        </div>

        <div class="checkout-form-grid">
          <div class="checkout-field checkout-field--full" @keyup="getCustomer()">
            <label class="checkout-label" for="pickup-email">Correo de compra</label>
            <input id="pickup-email" class="form-control checkout-input" type="email" v-model="email" name="email" placeholder="tu@email.com" required="">
          </div>

          <template v-if="require_account">
            <div class="checkout-field">
              <label class="checkout-label" for="pickup-phone">Teléfono de contacto</label>
              <input id="pickup-phone" class="form-control checkout-input" type="text" v-model="phone" name="phone" placeholder="0999999999" required="">
            </div>

            <div class="checkout-field">
              <label class="checkout-label" for="pickup-address">Dirección de facturación</label>
              <input id="pickup-address" class="form-control checkout-input" type="text" v-model="address" name="address" placeholder="Dirección de domicilio" required="">
            </div>

            <div class="checkout-field checkout-field--full">
              <label class="checkout-label" for="pickup-password">Contraseña de acceso</label>
              <input id="pickup-password" class="form-control checkout-input" type="password" v-model="password" name="password" placeholder="Crea una contraseña para revisar tus tickets rápido" required="">
            </div>
          </template>
        </div>

        <div v-if="require_account" class="checkout-check">
          <div
            class="checkout-check__button"
            :class="{ 'is-checked': acceptedTerms }"
            role="checkbox"
            tabindex="0"
            :aria-checked="acceptedTerms ? 'true' : 'false'"
            @click="toggleAcceptedTerms"
            @keydown.enter.prevent="toggleAcceptedTerms"
            @keydown.space.prevent="toggleAcceptedTerms"
          >
            <span class="checkout-check__box" aria-hidden="true"></span>
            <span class="checkout-check__text">Al continuar aceptas los <span class="checkout-check__link" role="button" tabindex="0" @click.stop="openTermsModal" @keydown.enter.prevent.stop="openTermsModal" @keydown.space.prevent.stop="openTermsModal">términos y condiciones</span>.</span>
          </div>
          <small v-if="termsError" class="checkout-check__error">Debes aceptar los términos y condiciones para continuar.</small>
        </div>

        <TermsModal v-model="showTermsModal" />

        <div v-if="userSearched" class="checkout-step__section">
          <h2 class="text-justify checkout-step__section-title"><strong>Responsable de retiro</strong></h2>
          <small class="form-text text-muted checkout-step__section-text">Completa un solo perfil de retiro para mantener la entrega clara y ordenada.</small>

          <article class="checkout-guest-card" style="animation-delay: 0ms;">
            <div class="checkout-guest-card__header">
              <span class="checkout-guest-card__eyebrow">Entrega principal</span>
                <strong class="checkout-guest-card__title">Datos de retiro</strong>
                <span class="checkout-guest-card__meta">Un solo responsable para una entrega elegante</span>
            </div>

            <div class="checkout-form-grid checkout-form-grid--compact">
              <div class="checkout-field">
                <label class="checkout-label">Nombres</label>
                <input class="form-control checkout-input" v-model="ticketsTable[0].first_name" type="text" name="first_name" placeholder="Nombre de quien retira" required="">
              </div>

              <div class="checkout-field">
                <label class="checkout-label">Apellidos</label>
                <input class="form-control checkout-input" v-model="ticketsTable[0].last_name" type="text" name="last_name" placeholder="Apellido de quien retira" required="">
              </div>

              <div class="checkout-field checkout-field--full" v-if="event.id==13">
                <label class="checkout-label">Instagram</label>
                <input class="form-control checkout-input" v-model="ticketsTable[0].ig" type="text" name="instagram" placeholder="Usuario de Instagram" required="">
              </div>

              <div class="checkout-field checkout-field--full" v-if="event.id==51">
                <label class="checkout-label">Documento</label>
                <input class="form-control checkout-input" v-model="ticketsTable[0].cc" type="text" name="document" placeholder="Numero de cedula o pasaporte" required="">
              </div>

              <div class="checkout-field checkout-field--full" v-if="event.id==8">
                <label class="checkout-label">Edad</label>
                <input class="form-control checkout-input" v-model="ticketsTable[0].age" type="text" name="age" placeholder="Edad" required="">
              </div>

              <div class="checkout-field checkout-field--full" v-if="event.id==14">
                <label class="checkout-label">Instagram</label>
                <input class="form-control checkout-input" v-model="ticketsTable[0].ig" type="text" name="instagram14" placeholder="Usuario de Instagram" required="">
              </div>

              <div class="checkout-field checkout-field--full" v-if="event.id==14 && ticketsTable[0] && (ticketsTable[0].product=='584' || ticketsTable[0].product=='585' || ticketsTable[0].product=='586' || ticketsTable[0].product=='587' || ticketsTable[0].product=='588' || ticketsTable[0].product=='589' || ticketsTable[0].product=='590' || ticketsTable[0].product=='591' || ticketsTable[0].product=='592' || ticketsTable[0].product=='593' || ticketsTable[0].product=='594' || ticketsTable[0].product=='595' || ticketsTable[0].product=='596' || ticketsTable[0].product=='597' || ticketsTable[0].product=='598' || ticketsTable[0].product=='599' || ticketsTable[0].product=='600' || ticketsTable[0].product=='601' || ticketsTable[0].product=='602' || ticketsTable[0].product=='603' || ticketsTable[0].product=='604' || ticketsTable[0].product=='605' || ticketsTable[0].product=='606' || ticketsTable[0].product=='607' || ticketsTable[0].product=='608' || ticketsTable[0].product=='609' || ticketsTable[0].product=='610' || ticketsTable[0].product=='611' || ticketsTable[0].product=='612' || ticketsTable[0].product=='613' || ticketsTable[0].product=='615' || ticketsTable[0].product=='614' || ticketsTable[0].product=='616' || ticketsTable[0].product=='617' || ticketsTable[0].product=='618' || ticketsTable[0].product=='502' || ticketsTable[0].product=='503' || ticketsTable[0].product=='789' || ticketsTable[0].product=='506')">
                <label class="checkout-label">Lugar de salida</label>
                <select class="form-control checkout-input" v-model="ticketsTable[0].entry" aria-label="Lugar de salida" required="">
                  <option value="" disabled selected>Lugar de salida</option>
                  <option value="Casa de las flores Cumbayá">Casa de las flores Cumbaya</option>
                  <option value="El Parque de los Kindes, Ficoa">El Parque de los Kindes, Ficoa</option>
                </select>
              </div>

              <div class="checkout-field" v-if="event.id==8">
                <label class="checkout-label">Talla</label>
                <select class="form-control checkout-input" v-model="ticketsTable[0].size" aria-label="Talla camiseta" required="">
                  <option value="" disabled selected>Talla camiseta</option>
                  <option value="XS/Extra Pequeño">XS/Extra Pequeño</option>
                  <option value="Small/Pequeño">Small/Pequeño</option>
                  <option value="Medium/Mediano">Medium/Mediano</option>
                  <option value="Large/Largo">Large/Largo</option>
                  <option value="XL/Extra Grande">XL/Extra Grande</option>
                </select>
              </div>

              <div class="checkout-field" v-if="event.id==8">
                <label class="checkout-label">Género</label>
                <select class="form-control checkout-input" v-model="ticketsTable[0].gender" aria-label="Género" required="">
                  <option value="0" disabled selected>Género</option>
                  <option value="1">Masculino</option>
                  <option value="2">Femenino</option>
                  <option value="3">Otro</option>
                </select>
              </div>

              <div v-for="(extra, extraIndex) in extraData" :key="extraIndex" class="checkout-field checkout-field--full">
                <label class="checkout-label">Dato adicional</label>
                <input class="form-control checkout-input" v-model="ticketsTable[extraIndex].last_name" type="text" :placeholder="extra.name" required="">
              </div>
            </div>
          </article>

          <div v-if="!loadingUser" class="checkout-step__actions checkout-step__actions--dock">
            <div class="checkout-step__actions-copy">
              <span class="checkout-step__summary-label">Paso 2 listo</span>
              <small class="checkout-step__summary-note">{{ ticketsTable.length }} acceso(s) listos para continuar</small>
            </div>
            <button class="btn btn-primary btn-block checkout-step__button liquid-page-button" type="submit">
              <span class="liquid-page-button__glow"></span>
              <span class="liquid-page-button__ring"></span>
              <span class="liquid-page-button__inner">
                <span class="liquid-page-button__copy">Continuar</span>
              </span>
            </button>
          </div>

          <div v-if="loadingUser" class="d-flex justify-content-center checkout-step__loader">
            <scaling-squares-spinner :size="60" color="#bec7d2" />
          </div>
        </div>
      </form>
    </div>
  </section>
</template>


  


<script>
import { apiService } from "../../common/api.services.js";
import { ScalingSquaresSpinner   } from 'epic-spinners';
import TermsModal from '../TermsModal.vue'


export default {
  
    name: 'GuestNameBar',
    props:{
        productsProp: {
          type: Object
       },
       order_finalF: {
       },

        event: {
           type: Object
       },

       selectedSeats:{
         type: Array
       },

       seatsProducts:{
         type: Array
       }

       
     },


     components: {
    ScalingSquaresSpinner,
    TermsModal,
  },

     

     data(){
      return{
        name: "",
        last_name: "",
        cc:"",
       events:[],
       next:null,
       ticketsTable:[],
       order:[],
       total: 0.00,
       fee: 0.00,
       email: "",
       phone: "",
        userSearched: false,
        password: "",
        loadingUser: false,
        loadingMain: false,
        term: "",
        address: "",
        require_account: false,
        customer: null,
        extraData: [],
        timer: null,
        looking: false,
        success: false,
        error: "",
        acceptedTerms: false,
        termsError: false,
        showTermsModal: false,
        
      }
     

   },

    created () {
      this.createTable()
  },

  
   methods:{


    


   

    createTable() {


///fetch('https://api.ipify.org/?format=json')
///.then(function(response) {
  //response.json().then(jsonData => {
    //console.log("Llega a ip");

    //console.log(jsonData);
  //});
//})
//.catch(function(error) {
  //console.log("Error ip");
  //7console.log(error)
//});




//fetch('https://ipapi.co/' + this.term + '/json/')
//.then(function(response) {
  //response.json().then(jsonData => {

    //console.log("Llega a  geo");

    //console.log(jsonData);

  //this.city=jsonData.city
  //this.region=jsonData.region


  //});
//})
//.catch(function(error) {
  //console.log("Error geo");
  //console.log(error)
  //this.city=""
 //// this.region=""
//});
    for (var i = 0; i < this.productsProp.length; i++){      
      for (let index = 0; index < this.productsProp[i].quantity; index++) {

        for (let j = 0; j < this.productsProp[i].quantity_factor; j++) {
          
        let uProduct =  {quantity:1, amount: this.productsProp[i].amount, product: this.productsProp[i].id , name: this.productsProp[i].name, is_courtesy:  this.productsProp[i].is_courtesy, first_name: "",  last_name: "", payment_term: 1, ig: "", age: "", cc: "", size: "", gender: 0, entry: "", seat: ""};
        this.ticketsTable=this.ticketsTable.concat(uProduct)
       
      }
      }
      } 


      let numberF = 0

      for (i = 0; i < this.seatsProducts.length; i++){  

      for (let index = 0; index < this.seatsProducts[i].quantity; index++) {

        for (let j = 0; j < this.seatsProducts[i].quantity_factor; j++) {
         
            let uProduct =  {quantity:1, amount: this.seatsProducts[i].amount, product: this.seatsProducts[i].id , name: this.seatsProducts[i].name, is_courtesy:  this.seatsProducts[i].is_courtesy, first_name: "",  last_name: "", payment_term: 1, ig: "", age: "", cc: "", size: "", gender: 0, entry: "", seat: this.selectedSeats[numberF].id, seat_name: this.selectedSeats[numberF].name, seat_assigned: true};
             this.ticketsTable=this.ticketsTable.concat(uProduct)
             numberF++
       
      }
      }
      } 



      








      if (this.event.quick_checkout_enabled){
        this.customer=1
        this.$emit('messageFromGuestName', this.ticketsTable, this.customer)
      }
    },


      getCustomer(){



        this.userSearched=false
      let endpoint = `/api/contacts/?email=${this.email}`; //open pos


      console.log(endpoint)

        clearTimeout(this.timer)

        this.timer = setTimeout(() => {
                
      apiService(endpoint).then(data => {
        if (data.length==0){
          this.require_account=true
          this.userSearched=true

        
        }else{
          this.customer = data[0];
          this.require_account=false
          this.userSearched=true

        }
        this.looking=false

      });
    
    }, 1250)
  },



  continueSale(){

     this.termsError = false

     if (this.userSearched){
      this.loadingUser=true


      let m_name=this.ticketsTable[0].first_name
      let l_name=this.ticketsTable[0].last_name


      for (let j = 0; j < this.ticketsTable.length; j++) {
        this.ticketsTable[j].first_name=m_name
        this.ticketsTable[j].last_name=l_name 
      }

      
      if(this.require_account==false){
  
      this.$emit('messageFromGuestName', this.ticketsTable, this.customer)
      }else{
        if (!this.acceptedTerms) {
          this.loadingUser=false
          this.termsError = true
          return
        }
        this.createCustomer()
      }
  }
    },

  toggleAcceptedTerms(){
    this.acceptedTerms = !this.acceptedTerms
    if (this.acceptedTerms) {
      this.termsError = false
    }
  },

  openTermsModal(){
    this.showTermsModal = true
  },


 createCustomer(){
    let first_name=this.ticketsTable[0].first_name
    let last_name=this.ticketsTable[0].last_name
    this.loadingMain=true
    this.success = false
    var profile = new Object();
    profile.phone =  this.phone
    profile.address = this.address
    profile.city = ""
    if (this.password==""){
      this.password="fomoplankk9876"

    }
    if(this.email!=""){
        let endpoint =  `/api/user/create`
       
    apiService(endpoint, "POST", {
  
    password: this.password,
    contact_profile: profile,
    first_name: first_name,
    last_name: last_name,
    email: this.email,
    username: this.email

  })
              .then(data => {
                  if (data.id){
                    this.customer=data
                    console.log(data)
                    this.require_account=false

                   this.continueSale()
        
                  }else{

                      alert("Error al crear la cuenta. Revisa los datos e inténtalo nuevamente.")
                      this.error="Verifique que los datos sean correctos"
                      this.loadingUser=false

                  }

        
               
              })

              

    

      }else {
        this.error="Llene todos los campos"
      }
    },


    


    openEvent(_id) {
      this.$router.push({ name: "event", params: { id: _id } });
    },


    increment (quantity, i) {
      this.availableTickets[i].quantity++
      this.availableTickets[i].total= (this.availableTickets[i].quantity * this.availableTickets[i].amount).toFixed(2)
       this.availableTickets[i].amount=this.availableTickets[i].amount*1
      this.total=this.total + this.availableTickets[i].amount
      this.total.toFixed(2)
    },
    decrement (quantity, i) {
      if(quantity === 0) {
         this.availableTickets[i].quantity=0
           }else{

     
        this.availableTickets[i].quantity--
      this.availableTickets[i].total= (this.availableTickets[i].quantity * this.availableTickets[i].amount).toFixed(2)
       this.availableTickets[i].amount=this.availableTickets[i].amount*1
      this.total=this.total - this.availableTickets[i].amount
      this.total.toFixed(2)
       }
    
      
    }

    
   }
}
</script>

<style>

#imagemPosterSlide{
  padding: 10px;
  
}

.container{
  justify-content:center
}


  
</style>



<style lang="css">
h1 {
  text-align: center;
  margin-bottom: 50px;
  margin-top: 50px;
}

.blog-card-blog {
  margin-top: 30px;
}

.blog-card {
  display: inline-block;
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  border-radius: 6px;
  color: rgba(0, 0, 0, 0.87);
  background: rgb(52, 58, 64);
  background-color: rgb(52, 58, 64);
}



.blog-card .blog-table {
  padding: 15px 30px;
}

.blog-table {
  margin-bottom: 0px;
}

.blog-category {
  position: relative;
  line-height: 0;
  margin: 15px 0;
}

.blog-text-success {
  color: rgb(198,197,197);
}

.blog-card-blog .blog-card-caption {
  margin-top: 5px;
}

.blog-card-caption {
  font-weight: 700;
  font-family: "Roboto Slab", "Times New Roman", serif;
}

.blog-card-caption, .blog-card-caption a {
  color: #333;
  text-decoration: none;
}

p {
  color: #3C4857;
  margin-top: 0;
  margin-bottom: 1rem;
}

.blog-card .ftr {
  margin-top: 15px;
}

.blog-card .ftr .author {
  color: #888;
}

.blog-card .ftr div {
  display: inline-block;
}

.blog-card .author .avatar {
  width: 36px;
  height: 36px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
}

.blog-card .ftr .stats {
  position: relative;
  top: 1px;
  font-size: 14px;
}

.blog-card .ftr .stats {
  float: right;
  line-height: 30px;
}

a {
  text-decoration: none;
}


 .d-inline .input {
    border: 0;
    width: 2.5rem;
    text-align: center;
    padding: 0 .5rem;
  }

.quantity-toggle .button {
    background: rgb(198,197,197);
    font-size: 1rem;
    cursor: pointer;
    color: white;
  }


.cont{
   padding-right: 50px;
   padding-left: 50px;
}
.rw{
   padding-right: 5px;
   padding-left: 5px;
  border-top: 1px solid white;



}

@media (max-width: 768px) {
.cont {
    padding-left: 10px;
    padding-right: 10px;
}

.rw{
   padding-right: 10px;
   padding-left: 10px;


}
}


    
</style>

   
